import React, { useState, useEffect, useRef } from "react";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
import paginationFactory from "react-bootstrap-table2-paginator";
import { Stepper, Step } from "react-form-stepper";
import { useNavigate, useParams } from "react-router-dom";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Card, Button, ButtonGroup, Dropdown } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../utils/Css/Marketing.css";
import "../../../../utils/Css/Campagne.css";
import campagneSMSService from "./../../../../services/MarketingService/CampagneSMSService"
import { Swal } from 'sweetalert2';
import clientService from "./../../../../services/MarketingService/ClientService.jsx";

import { TextField } from "@material-ui/core";
import moment from "moment";
const stepTitle = ["Creation", "Destinataires", "Date de l'envoi"];

function EditCampagneS() {
  const [nouvelleCampagneSMS, setNouvelleCampagneSMS] = useState({});
  //const [clientIds, setClientIds] = useState([]); // pour recuperer les clients selectionnee
  const [clients, setClients] = useState([]); // pour recuperer les clients
  const [selectedClients, setSelectedClients] = useState({});
  const [debutDate, setdebutDate] = useState(null);
  const [success, setSuccess] = useState(null);
  const [erreur, setErreur] = useState(null);
  const [data, setData] = useState({});
  const { id } = useParams();
  const [formData, setFormData] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [selectedClientCount, setSelectedClientCount] = useState(0); // Nouvelle variable
  const [selectAll, setSelectAll] = useState(false);
  const formattedDateTime = moment(data.debutDate).format("YYYY-MM-DD HH:mm");

  // methode pour sweetAlert : pour afficher le success de la modification de publication
  const handleSuccess = () => {
    Swal.fire({
      icon: "success",
      html: `<strong>${success}</strong>`,
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
    });
  };

  //useEffect
  useEffect(() => {
    if (success) {
      handleSuccess();
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await campagneSMSService.getCampagneSMSByID(id);
        setData(response.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, [id]);

  useEffect(() => {
    // Load clients from API
    async function loadClients() {
      try {
        const response = await clientService.AfficherListClients();
        const loadedClients = response.data;

        // Set initial selected state for clients in current campagneSMS to true
        const initialSelectedState = {};
        for (const client of loadedClients) {
          initialSelectedState[client.id] = false;
        }
        if (data && data.clients) {
          for (const client of data.clients) {
            initialSelectedState[client.id] = true;
          }
        }
        setSelectedClients(initialSelectedState);
        setSelectAllChecked(
          Object.values(initialSelectedState).every((isSelected) => isSelected)
        );

        setClients(loadedClients);
      } catch (error) {
        console.error("Failed to load clients:", error);
      }
    }
    loadClients();
  }, [data]);

  // Method to handle select all checkbox change

  // Recalculate selectedClientCount whenever selectedClients changes
  useEffect(() => {
    const count = Object.values(selectedClients).filter(Boolean).length;
    setSelectedClientCount(count);
  }, [selectedClients]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleUpdateCampagne = async (event) => {
    event.preventDefault();

    const selectedClientIds = Object.keys(selectedClients).filter(
      (clientId) => selectedClients[clientId]
    );

    const updatedCampagne = {
      ...data,
      ...formData,
      budget: selectedClientCount * 50,
    };

    campagneSMSService
      .mettreAJourCampagneSMS(updatedCampagne, selectedClientIds, id)
      .then(() => {
        setData(updatedCampagne);
        setSuccess("Modification validée avec succès !");
      });
  };
  // filter date debut
  const onChangeStartDate = (event) => {
    setFormData({
      ...formData,
      debutDate: event.target.value,
    });
  };
  //pagination
  const options = {
    sizePerPage: 7,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    paginationPosition: "bottom",
  };

  // route
  const navigate = useNavigate();

  //Stepper
  const [activeStep, setActiveStep] = useState(0);

  const handleNextStep = () => {
    setActiveStep(Math.min(activeStep + 1, 2));
  };
  const handleNextStepToFinal = () => {
    setActiveStep(Math.min(activeStep + 2, 2));
  };

  const handleBackStep = () => {
    setActiveStep(Math.max(activeStep - 1, 0));
  };
  const handleBackStepToStart = () => {
    setActiveStep(Math.max(activeStep - 2, 0));
  };

  const stepStyleConfig = {
    activeBgColor: "#848687",
    completedBgColor: "#333",
  };

  //condition sur radio button pour importer fichier de phoneNumber de clients
  const [isImporting, setIsImporting] = useState(false);
  const [attachment, setAttachment] = useState(null);

  const handleRadioChange = (event) => {
    if (event.target.value === "importer") {
      setIsImporting(true);

    } else {
      setIsImporting(false);
    }
  };

  const handleAttachmentChange = (event) => {
    setAttachment(event.target.files[0]);
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;

    if (name === "selectAll") {
      const newSelectedClients = {};

      // If the "Select All" checkbox is checked, set all clients as selected
      if (checked) {
        clientsData.forEach((client) => {
          newSelectedClients[client.id] = true;
        });
      }

      setSelectedClients(newSelectedClients);
    } else {
      setSelectedClients((prevSelectedClients) => ({
        ...prevSelectedClients,
        [name]: checked,
      }));
    }
  };

  const handleSelectAllCheckboxChange = (event) => {
    const { checked } = event.target;
    const updatedSelectedClients = clients.reduce(
      (acc, client) => ({
        ...acc,
        [client.id]: checked,
      }),
      {}
    );
    setSelectedClients(updatedSelectedClients);
  };

  const isRowSelected = (row) => {
    return selectedClients[row.id] ?? false;
  };

  const clientsData = clients.map((client) => {
    return {
      id: client.id,
      firstName: client.firstName,
      lastName: client.lastName,
      phoneNumber: client.phoneNumber,
      age: client.age,
      rue: client.rue,
      ville: client.ville,
      pays: client.pays,
      checkbox: (
        <td>
          <input
            type="checkbox"
            name={client.id}
            value={client.id}
            checked={selectedClients[client.id]}
            onChange={handleCheckboxChange}
          />
        </td>
      ),
    };
  });
  const handleDeselectAllButtonClick = () => {
    setSelectedClients({});
  };

  const columns = [
    {
      dataField: "id",
      text: "",
      formatter: (cellContent, row) => (
        <input
          type="checkbox"
          name={row.id}
          value={row.id}
          checked={isRowSelected(row)}
          onChange={handleCheckboxChange}
        />
      ),
      headerFormatter: () => {
        return (
          <div>
            <input
              type="checkbox"
              checked={Object.values(selectedClients).every(
                (isSelected) => isSelected
              )}
              onChange={handleSelectAllCheckboxChange}
            />
          </div>
        );
      },
    },

    {
      dataField: "firstName",
      text: "Nom",
    },
    {
      dataField: "lastName",
      text: "Prenom",
    },
    {
      dataField: "phoneNumber",
      text: "Numero",
    },
    {
      dataField: "age",
      text: "Age",
    },
    {
      dataField: "rue",
      text: "Rue",
    },
    {
      dataField: "ville",
      text: "Ville",
    },
    {
      dataField: "pays",
      text: "Pays",
    },
  ];

  return (

    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Campagne SMS </h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <a href="#">Marketing</a>
                </li>
                <li className="breadcrumb-item">
                  <a href="/Campagne">Campagne</a>
                </li>
                <li className="breadcrumb-item">
                  <a href="/Campagne/PageCampagneS">SMS</a>
                </li>
                <li className="breadcrumb-item active">Modification</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      {/* /.content-header */}


      {/* content */}
      <section className="content mt-3">
        {/* container-fluid */}
        <div className="container-fluid">
          <div className="card card-dark">
            <div className="card-header">
              <h3 className="card-title">Modifier Campagne SMS </h3>
            </div>
            <div className="card-body">
              <Stepper styleConfig={stepStyleConfig} activeStep={activeStep}>
                {stepTitle.map((title) => (
                  <Step key={title} label={title} />
                ))}
              </Stepper>
              {activeStep === 0 ? (
                <div className="row">
                  <div className="col">
                    <div className="form-group">
                      <label>Nom</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputEmail1"
                        placeholder="Nom"
                        name="nom"
                        value={formData.nom || data.nom}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="form-group">
                      <label> Contenu</label>
                      <textarea
                        className="form-control"
                        rows="3"
                        placeholder="Contenu SMS ..."
                        name="contenu"
                        value={formData.contenu || data.contenu}
                        onChange={handleInputChange}
                      />
                    </div>


                    <div className="form-group">
                      <label> Contact</label>
                      <textarea
                        className="form-control"
                        rows="3"
                        placeholder="Contact SMS ..."
                        name="donneesContact"
                        value={
                          formData.donneesContact || data.donneesContact
                        }
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                </div>
              ) : null}
              {activeStep === 1 ? (
                <>
                  <Card className="Campagne-card-buttons">
                    <Card.Body>
                      <div className="row">
                        <div className="col">
                          <Card
                            style={{
                              backgroundColor: "#848687",
                              color: "white",
                            }}
                          >
                            <Card.Body>
                              <div className="row">
                                <div className="col-3 text-center">
                                  <label className="col">
                                    firstNamebre de Destinataires
                                  </label>
                                  <label className="col">
                                    {selectedClientCount}
                                  </label>
                                </div>
                                <div className="col-8">
                                  <label className="col">Filtres</label>
                                </div>
                              </div>
                            </Card.Body>
                          </Card>
                        </div>
                        <div className="w-100"></div>
                        <div className="col">
                          <div className="table-container thead-dark mb-3">
                            <BootstrapTable
                              keyField="id"
                              data={clientsData}
                              columns={columns}
                              bordered={false}
                              condensed
                              pagination={paginationFactory(options)}
                              defaultSorted={[
                                {
                                  dataField: "creationDate",
                                  order: "asc",
                                },
                              ]}
                              faultSortDirection="asc"
                              noDataIndication={() => "No data found"}
                              headerClasses="thead-dark"
                            />
                          </div>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                  {/* /.table */}
                </>
              ) : null}
              {activeStep === 2 ? (
                <>
                  <Card className="Campagne-card-buttons">
                    <Card.Body>
                      <div className="row">
                        <div className="col">
                          <Card
                            style={{
                              backgroundColor: "#848687",
                            }}
                          >
                            <Card.Body>
                              <div className="row">
                                <div className="col-3 text-center">
                                  <label className="col">Type</label>
                                  <label className="col">Email</label>
                                </div>
                                <div className="col-3 text-center">
                                  <label className="col">
                                    Destinataires
                                  </label>
                                  <label className="col">
                                    {selectedClientCount}
                                  </label>
                                </div>

                                <div className="col-3 text-center">
                                  <label htmlFor="startDate">
                                    Date de l'envoi{" "}
                                  </label>
                                  <div className="col-3 text-center">
                                    <label className="col">
                                      <TextField
                                        variant="outlined"
                                        value={formData.debutDate}
                                        defaultValue={formattedDateTime}
                                        name="debutDate"
                                        onChange={onChangeStartDate}
                                        id="datetime-local"
                                        type="datetime-local"
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        size="small"
                                      // className="mt-2"
                                      //style={{ backgroundColor: "white"}}
                                      />
                                    </label>
                                  </div>
                                </div>

                                <div className="col-3 text-center">
                                  <label className="col">Cout</label>
                                  <label className="col">
                                    {selectedClientCount * 50}
                                  </label>
                                </div>
                              </div>
                            </Card.Body>
                          </Card>
                        </div>
                        <div className="w-100"></div>

                        <div className="col">
                          <Card>
                            <Card.Body>
                              <div className="row">
                                <h5 className="col-12 text-center font-weight">
                                  Aperçu de l'SMS envoyé aux
                                  <span> {selectedClientCount} </span>
                                  destinataires
                                </h5>
                                <div className="col-12 text-center text-muted">
                                  <small>
                                    Cet aperçu est affiché à titre
                                    indicatif, le résultat final peut être
                                    différent
                                  </small>
                                </div>

                                <div className="container mt-3">
                                  <div className="row">
                                    <div className="col-sm"></div>
                                    <div className="col-sm">
                                      <div className="row">
                                        <div className="col">
                                          <label>Contenu :</label>
                                        </div>
                                        <div className="w-100"></div>

                                        <div className="col">
                                          <div>
                                            {formData.contenu ||
                                              data.contenu}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row  mt-3">
                                        <div className="col">
                                          <label>Contact :</label>
                                        </div>
                                        <div className="w-100"></div>

                                        <div className="col">
                                          {formData.donneesContact ||
                                            data.donneesContact}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-sm"></div>
                                  </div>
                                </div>
                              </div>
                            </Card.Body>
                          </Card>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                  {/* /.table */}
                </>
              ) : null}
            </div>

            <div className="card-footer">
              <div className="row">
                <div className="col">
                  {/* condition sur lsuivant et precedent */}
                  <FaChevronLeft
                    onClick={
                      isImporting ? handleBackStepToStart : handleBackStep
                    }
                  />
                  <FaChevronRight
                    onClick={
                      isImporting ? handleNextStepToFinal : handleNextStep
                    }
                  />
                </div>

                {/* condition sur les button Ajouter + annuler */}
                <div className="col text-right" style={{ width: "100%" }}>
                  <Button
                    className="btn btn-secondary mr-2"
                    onClick={() => navigate("/Campagne/PageCampagneS")}
                    style={{ width: "150px" }}
                  >
                    Annuler
                  </Button>
                  <Button
                    className="btn btn-dark"
                    disabled={activeStep !== 2}
                    style={{ width: "150px" }}
                    onClick={() => navigate("/Campagne/PageCampagneS")}
                  >
                    Modifier
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /.container-fluid */}
      </section>
    </div>

  );
}

export default EditCampagneS;
